import { Dispatch, SetStateAction, useCallback, useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { setUser } from '../store/user'
import { apiGet, apiPost } from '../hooks/useApi'
import { useSessionStorage } from '../hooks/useStorage'
import { Context } from './Wrapper'
import NavbarDesktop from './Navbar/NavbarDesktop'
import NavbarMobile from './Navbar/NavbarMobile'

interface Props {
  menuOpen: boolean
  setMenuOpen: Dispatch<SetStateAction<boolean>>
}

declare global {
  interface Window {
    CookieInformation: any
  }
}

interface Map {
  [key: string]: {
    [key: string]: string | undefined
  }
}

const links: Map = {
  et: {
    menuItem1: 'https://www.e-krediidiinfo.ee',
    menuItem2: 'https://www.e-krediidiinfo.ee/sanktsioonid',
    menuItem3: 'https://target.creditinfo.ee?lang=et',
    menuItem4: 'https://marketreview.creditinfo.ee/et'
  },
  en: {
    menuItem1: 'https://www.e-krediidiinfo.ee',
    menuItem2: 'https://www.e-krediidiinfo.ee/sanktsioonid',
    menuItem3: 'https://target.creditinfo.ee?lang=en',
    menuItem4: 'https://marketreview.creditinfo.ee/en'
  }
}

const dropdownLinks: { [key: string]: string } = {
  menuItem1Dropdown1: 'https://www.e-krediidiinfo.ee/',
  menuItem1Dropdown2: 'https://www.e-krediidiinfo.ee/maksehaired',
  menuItem1Dropdown3: 'https://www.e-krediidiinfo.ee/seire',
  menuItem1Dropdown4: 'https://www.e-krediidiinfo.ee/krediidiriskid',
  menuItem1Dropdown5: 'https://www.e-krediidiinfo.ee/nimekirjad'
}

function Navbar ({ menuOpen, setMenuOpen }: Props): JSX.Element {
  const navigate = useNavigate()
  const context = useContext(Context)
  const dispatch = useDispatch()

  const user = useSelector((state: any) => state.user)
  const [users, setUsers] = useSessionStorage<User[]>('users', [])
  const [toggleMobileAccountSettings, setToggleMobileAccountSettings] = useState<boolean>(false)

  const isActive = useCallback((lang: any): boolean => context.locale === lang, [context.locale])

  const getLink = useCallback((menuItem: string): string | undefined => context.locale && links[context.locale][menuItem], [context.locale, links])

  const signIn = useCallback((): void => {
    navigate(`/sign-in?next=${location.pathname}`)
  }, [navigate, location.pathname])

  const signOut = useCallback(async (): Promise<void> => {
    const { status, error } = await apiGet('authLogout')

    if (error !== undefined) return
    if (status !== 'success') return

    dispatch(setUser(null))
    setUsers([])

    location.reload()
  }, [apiGet, dispatch, setUsers, location])

  const selectUser = useCallback(async (userId: number): Promise<void> => {
    const { id, firstName, lastName, companyName, error } = await apiPost('authChooseUser', { body: { id: userId } })

    if (error !== undefined) return

    dispatch(setUser({ id, firstName, lastName, companyName }))
  }, [apiPost, dispatch, setUser])

  const selectLanguage = useCallback((language: string): void => {
    context.selectLanguage?.(language)

    document.getElementById('CookieConsent')?.setAttribute('data-culture', language)
    window.CookieInformation.loadConsent()

    localStorage.setItem('language', language)
  }, [context.selectLanguage])

  return (
    <nav
      className="navbar-dark bg-dark fixed top-0 w-full navbar navbar-expand-xl fixed-top"
      style={{ zIndex: 1 }}
    >
      <NavbarDesktop
        dropdownLinks={dropdownLinks}
        getLink={getLink}
        isActive={isActive}
        menuOpen={menuOpen}
        selectLanguage={selectLanguage}
        selectUser={selectUser}
        setMenuOpen={setMenuOpen}
        setToggleMobileAccountSettings={setToggleMobileAccountSettings}
        signIn={signIn}
        signOut={signOut}
        toggleMobileAccountSettings={toggleMobileAccountSettings}
        user={user}
        users={users}
      />
      <NavbarMobile
        dropdownLinks={dropdownLinks}
        getLink={getLink}
        isActive={isActive}
        menuOpen={menuOpen}
        selectLanguage={selectLanguage}
        selectUser={selectUser}
        setMenuOpen={setMenuOpen}
        setToggleMobileAccountSettings={setToggleMobileAccountSettings}
        signIn={signIn}
        signOut={signOut}
        toggleMobileAccountSettings={toggleMobileAccountSettings}
        user={user}
        users={users}
      />

    </nav>

  )
}

export default Navbar
